import { render, staticRenderFns } from "./myEXiaoZhi.vue?vue&type=template&id=867459e4"
import script from "./myEXiaoZhi.vue?vue&type=script&lang=js"
export * from "./myEXiaoZhi.vue?vue&type=script&lang=js"
import style0 from "./myEXiaoZhi.vue?vue&type=style&index=0&id=867459e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports